var map = {
	"./cutting/刀具/车刀/45chedao.prt.jpg": "c8de",
	"./cutting/刀具/车刀/90waiyuanchedao.prt.jpg": "841f",
	"./cutting/刀具/车刀/chedao.prt.jpg": "953b",
	"./cutting/刀具/车刀/neiluowenchedao.prt.jpg": "c584",
	"./cutting/刀具/车刀/tangkongchedao.prt.jpg": "8a76",
	"./cutting/刀具/车刀/wailuowenchedao.prt.jpg": "4127",
	"./cutting/刀具/钻刀/zhongxinzuan.prt.jpg": "e97d",
	"./cutting/刀具/钻刀/zuankong.prt.jpg": "187c",
	"./cutting/刀具/钻刀/zuankong_2.prt.jpg": "6dac",
	"./cutting/刀具/铣刀/2renlixidao.prt.jpg": "6e3a",
	"./cutting/刀具/铣刀/jupianxidao.prt.jpg": "ed9b",
	"./cutting/刀具/铣刀/lixidao.prt.jpg": "e9c1",
	"./cutting/刀具/铣刀/mianxidao.prt.jpg": "5b01",
	"./cutting/刀具/铣刀/qiutouxidao.prt.jpg": "d240",
	"./cutting/刀具/铣刀/t-xidao.prt.jpg": "0781",
	"./cutting/刀具/铣刀/xidao.prt.jpg": "5eb8",
	"./cutting/刀具/铣刀/xineiluowen.prt.jpg": "b73f",
	"./cutting/刀具/铣刀/xineiluowen_2.prt.jpg": "bb07",
	"./cutting/刀具/铣刀/yanwei-xidao.prt.jpg": "fa1c",
	"./cutting/刀具/铰刀/jiaodao.prt.jpg": "5b6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "94a7";